var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Entity } from '@decahedron/entity';
import moment from 'moment';
export var CallLogOutcomes;
(function (CallLogOutcomes) {
    CallLogOutcomes["BUSY"] = "busy";
    CallLogOutcomes["QUALIFIED"] = "qualified";
    CallLogOutcomes["UNQUALIFIED"] = "unqualified";
    CallLogOutcomes["UNREACHABLE"] = "unreachable";
})(CallLogOutcomes || (CallLogOutcomes = {}));
export var CallLogAction;
(function (CallLogAction) {
    CallLogAction["DO_NOTHING"] = "do_nothing";
    CallLogAction["REJECT_CANDIDATE"] = "reject";
    CallLogAction["MOVE_CANDIDATE"] = "move_to";
})(CallLogAction || (CallLogAction = {}));
var CallLog = /** @class */ (function (_super) {
    __extends(CallLog, _super);
    function CallLog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.jobId = null;
        _this.talentId = null;
        _this.pipelineStageId = null;
        _this.outcome = null;
        _this.comment = null;
        _this.action = null;
        _this.createdAt = null;
        return _this;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    CallLog.prototype.fromJson = function (jsonData) {
        var entity = _super.prototype.fromJson.call(this, jsonData);
        entity.createdAt = moment(entity.createdAt);
        return entity;
    };
    CallLog.prototype.toJson = function (toSnake, asString) {
        var json = _super.prototype.toJson.call(this, toSnake, asString);
        if (json.action === 'do_nothing') {
            json.action = null;
        }
        var createdAtKey = toSnake ? 'created_at' : 'createdAt';
        json[createdAtKey] = this.createdAt.toISOString();
        return json;
    };
    return CallLog;
}(Entity));
export { CallLog };
